import { withPrefix } from "gatsby";
import { TFunction, useTranslation } from "gatsby-plugin-react-i18next";
import { MutableRefObject, useEffect, useState } from "react";

import { blogUrl } from "../consts/urls";

// The web app is shut down; calls to action that used to go there now lead to the contact page.
export const useContactUrl = () => {
  const { i18n } = useTranslation();
  const languagePrefix = i18n.language === "en" ? "" : `/${i18n.language}`;
  return withPrefix(`${languagePrefix}/contact/`);
};

export const useBlogUrl = () => {
  return blogUrl;
};

export const useDocPrefix = () => {
  const { i18n } = useTranslation();

  return withPrefix(`/docs/${i18n.language}/`);
};

export const getLpUrl = () => {
  const lpUrl = process.env.GATSBY_LP_URL;
  return lpUrl;
};

export const useOnScreen = (ref: MutableRefObject<HTMLElement>) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
};

// TODO: Check if there is another way to call the t: TFunction<"translation">
export const getTranslationList = (t: TFunction<"translation">, i18nKey: string) => {
  const arraySize = t(i18nKey, { returnObjects: true }).length;
  const proposalList = new Array(arraySize).fill(0).map((_, i) => `${i18nKey}.${i}`);

  return proposalList;
};

export const useScript = (url: string, type: string | null, async: boolean, defer: boolean) => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    if (type != null) {
      script.type = type;
    }
    if (async) {
      script.async = true;
    }
    if (defer) {
      script.defer = true;
    }
    document.head.appendChild(script);
  }, [url]);
};
